import React from "react";
import {
  BaseEdge,
  EdgeProps,
} from "reactflow";
import { useAgentDropHoverEdge } from "../../hook/useAgentDropHoverEdge";
import { EDGE_DROP_HOVER_ATTR, edgeDropHighlightStyle } from "./edgeDropHighlight";
import { EdgeAgentBadges } from "../agents/attach/EdgeAgentBadges";
import { useEdgePath } from "./useEdgePath";

export default function BiDirectionalEdge({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  markerStart,
  data
}: EdgeProps) {
  const { path: edgePath, labelX, labelY, emphasized } = useEdgePath({
    id,
    source,
    target,
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // const [edgePath, labelX, labelY] = getStraightPath({
  //   sourceX,
  //   sourceY,
  //   targetX,
  //   targetY
  // });

  // const [edgePath, labelX, labelY] = getSimpleBezierPath({
  //   sourceX,
  //   sourceY,
  //   sourcePosition,
  //   targetX,
  //   targetY,
  //   targetPosition,
  // });

  // const [edgePath, labelX, labelY] = getSmoothStepPath({
  //   sourceX,
  //   sourceY,
  //   sourcePosition,
  //   targetX,
  //   targetY,
  //   targetPosition,
  // });

  const dropHovered = useAgentDropHoverEdge(id);

  // Always-mounted <g>: see the twin comment in UniDirectionalEdge (#296).
  return (
    <g {...{ [EDGE_DROP_HOVER_ATTR]: dropHovered ? 'true' : undefined }}>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={edgeDropHighlightStyle(data?.keywordHighlighted ? 'blue' : emphasized ? 'darkred' : 'red', dropHovered)}
      />
      <EdgeAgentBadges edgeId={id} labelX={labelX} labelY={labelY} />
    </g>
  );
}
